import ConfirmProposalModal from "./ConfirmProposalModal";
export default ConfirmProposalModal;
